export default function Menu() {
  return <div>Reports</div>;
}